<template>
  <sModal
    v-model="dialog"
    :title="$t('Common.Feedback.Title')"
    @close="$emit('update:open', false)">
    <v-fab-transition
      slot="activator">
      <sTooltip
        :content="$t('Common.Feedback.Title')"
        :disabled="dialog"
        placement="top"
        type="dark">
        <v-btn
          v-show="!dialog"
          ref="feedBackBtn"
          class="feed-back-btn"
          color="var(--color-main-green)"
          data-qa="feed-back-btn"
          elevation="12"
          fab
          fixed
          small
          :style="styleFeedBackBtn"
          @mousedown="dragMouseDown"
          @mouseleave="savePositionBtn">
          <sIcon
            class="mb-1"
            color="var(--v-secondary__green_not_active-base)"
            size="24"
            type="alert-outline"/>
        </v-btn>
      </sTooltip>
    </v-fab-transition>

    <sForm
      ref="feedbuckForm"
      :disabled="loading"
      label-position="top"
      :model="feedback"
      :rules="rules">
      <sFormItem
        data-qa="feedbuck-module"
        :label="$t('Common.Module')"
        prop="path">
        <sSelect
          class="width-100"
          data-qa="feedbuck-module-select"
          :placeholder="$t('Common.Select')"
          :value.sync="feedback.path">
          <sOption
            v-for="moduleItem in modules"
            :key="`feedbuck-module-item-${moduleItem.value}`"
            class="px-8"
            :data-qa="`feedbuck-module-item-${moduleItem.value}`"
            :label="moduleItem.text"
            :value="moduleItem.value"/>
        </sSelect>
      </sFormItem>
      <sFormItem
        data-qa="feedbuck-feedback-types"
        :label="$t('Common.Feedback.Type')"
        prop="type">
        <sSelect
          class="width-100"
          data-qa="feedbuck-feedback-types-select"
          :placeholder="$t('Common.Select')"
          :value.sync="feedback.type">
          <sOption
            v-for="feedbackTypeItem in feedbackTypes"
            :key="`feedbuck-feedback-types-item-${feedbackTypeItem.value}`"
            class="px-8"
            :data-qa="`feedbuck-feedback-types-item-${feedbackTypeItem.value}`"
            :label="feedbackTypeItem.text"
            :value="feedbackTypeItem.value"/>
        </sSelect>
      </sFormItem>
      <sFormItem
        data-qa="feedbuck-feedback-caption"
        :label="$t('Common.Caption')"
        prop="name">
        <sInput
          clearable
          data-qa="feedbuck-feedback-caption"
          :max-length="4000"
          :value.sync="feedback.name"/>
      </sFormItem>
      <sFormItem
        data-qa="feedbuck-feedback-description"
        :label="$t('Common.Description')"
        prop="description">
        <sInput
          clearable
          data-qa="feedbuck-feedback-description"
          :max-length="4000"
          max-rows="3"
          rows="6"
          type="textarea"
          :value.sync="feedback.description"/>
      </sFormItem>
    </sForm>
    <ImportBlock
      class="mt-5"
      :create-file-handler="createFileHandler"
      :disabled="loading"
      :files.sync="feedback.files"/>

    <div
      key="footer"
      slot="footer">
      <sButton
        key="btn-ok"
        data-qa="btn-ok-dialog"
        :loading="loading"
        type="black"
        @click="sendFeedback">
        {{ $t('Common.Send') }}
      </sButton>
      <sButton
        key="btn-cancel"
        data-qa="btn-close-dialog"
        :loading="loading"
        type="text"
        @click="dialog = false">
        {{ $t('Common.Cancel') }}
      </sButton>
    </div>
  </sModal>
</template>
<script>
import ImportBlock from 'components/common/blocks/ImportBlock.vue'

import FeedbackApi from '@/api/feedbackApi'
import { storageMixin } from 'mixins'
const feedback_api = new FeedbackApi()
import { FeedbackFile } from '@/types/commonFile.js'

import { mapGetters } from 'vuex'
import html2canvas from 'html2canvas'


export default {
  name: 'feedbackButton',
  mixins: [ storageMixin ],
  data() {
    return {
      tooltip: false,
      dialog: false,
      drag: false,
      rules: {},
      feedback: {
        path: '',
        type: 'PROPOSAL',
        name: '',
        description: '',
        files: [],
      },
      feedbackTypes: [
        { value: 'PROPOSAL', text: this.$t('Common.Feedback.ProposalType')  },
        { value: 'BUG', text: this.$t('Common.Feedback.ErrorType') },
        { value: 'TRANSLATES', text: this.$t('Common.Feedback.TranslatesType')  }
      ],
      modules: [
        { value: 'ERROR', text: this.$t('Common.Feedback.ErrorPage') },
        { value: 'TENDERS', text: this.$t('Common.Feedback.TendersModule') },
        { value: 'PURCHASING', text: this.$t('Common.Feedback.ApplicationModule') },
        { value: 'PLANNING', text: this.$t('Common.Feedback.PlaningModule') },
        { value: 'STOP_LIST', text: this.$t('Common.Feedback.StoplistModule') },
        { value: 'SUPPLIERS', text: this.$t('Common.Feedback.SuppliersModule') },
        { value: 'FEATURES', text: this.$t('Common.Feedback.FeaturesModule') }
      ],
      loading: false,
      snapshot: null,
      positionBtn: {
        left: null,
        top: null,
        right: 16,
        bottom: 80,
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'GET_USER'
    }),
    styleFeedBackBtn() {
      const style = {}

      if (this.positionBtn.left) { style.left = `${this.positionBtn.left}px` }
      if (this.positionBtn.top) { style.top = `${this.positionBtn.top}px` }
      if (this.positionBtn.right && !this.positionBtn.left) { style.right = `${this.positionBtn.right}px` }
      if (this.positionBtn.bottom && !this.positionBtn.top) { style.bottom = `${this.positionBtn.bottom}px` }

      return style
    },
    /*disabled_submit() {
      return !this.type || !this.feedback.path || !this.feedback.name || !this.feedback.description
    }*/
  },
  mounted() {
    this.$refs.feedBackBtn.$el.onmouseup = this.open
    try {
      this.$_getPropFromDBStorage('feedBtn', {
        'left': null,
        'top': null,
        'right': 16,
        'bottom': 80
      })
        .then((feedBtnPosition) => {
          if (feedBtnPosition) {
            if (feedBtnPosition.left > window.innerWidth) { feedBtnPosition.left = null }
            if (feedBtnPosition.top > window.innerHeight) { feedBtnPosition.top = null }

            this.positionBtn = {
              left: feedBtnPosition.left,
              top: feedBtnPosition.top,
              right: feedBtnPosition.right,
              bottom: feedBtnPosition.bottom
            }
          }
        })
    } catch (_) {
      //
    }
  },
  methods: {
    open() {
      const that = this
      this.dialog = true
      const defaultRules = [
        {
          type: 'string',
          trigger: 'change',
          required: true,
          message: this.$t('Validate.Required')
        },
        {
          trigger: 'change',
          min: 2,
          message: this.$t('Validate.minLength', {number: 2, type: this.$tc('Common.characters', 2) })
        },
        {
          trigger: 'change',
          max: 4000,
          message: that.$t('Validate.maxLength', {number: 4000, type: that.$tc('Common.characters', 10) })
        }
      ]
      this.rules = {
        path: defaultRules,
        type: defaultRules,
        name: defaultRules,
        description: defaultRules,
      }
    },
    savePositionBtn() {
      this.drag = false
      if (this.$refs.feedBackBtn.$el.style.display === 'none') { return }
      const itemProps = this.$refs.feedBackBtn.$el.getBoundingClientRect()

      this.positionBtn.left = itemProps.left
      this.positionBtn.top = itemProps.top
      this.positionBtn.right = window.innerWidth - this.positionBtn.left - itemProps.width
      this.positionBtn.bottom = window.innerHeight - this.positionBtn.top - itemProps.height

      const valueLocalStorage = {
        'left': this.positionBtn.left,
        'top': this.positionBtn.top,
        'right': this.positionBtn.right,
        'bottom': this.positionBtn.bottom
      }

      this.$_savePropToDBStorage('feedBtn', valueLocalStorage)
    },
    dragMouseDown() {
      this.tooltip = false
      document.onmouseup = this.closeDragElement
      document.onmousemove = this.elementDrag
    },
    elementDrag(e) {
      this.drag = true
      this.tooltip = false

      let elmnt = this.$refs.feedBackBtn.$el
      elmnt.onmouseup = () => {}
      e = e || window.event
      elmnt.style.top = e.clientY - 20 + 'px'
      elmnt.style.left = e.clientX - 20 + 'px'
    },
    closeDragElement() {
      document.onmouseup = null
      document.onmousemove = null
      this.$refs.feedBackBtn.$el.onmouseup = this.open
    },
    async sendFeedback() {
      this.$refs.feedbuckForm.validate().then(async (valid) => {
        if (!valid) { return }

        this.loading = true

        try {
          let task = {
            name: this.feedback.name,
            description: this.feedback.description,
          }
          // task.description += addInfo

          // безопасная сериализация store (удаляет циклы и проблемные объекты)
          const safeStringify = (obj) => {
            const seen = new WeakSet()
            return JSON.stringify(obj, function (key, value) {
              // Исключаем проблемные объекты
              if (value instanceof Window || 
                  value instanceof HTMLElement || 
                  value instanceof Node ||
                  key === 'window' ||
                  key === 'document' ||
                  key === '$el' ||
                  key === '$refs' ||
                  key === '$parent' ||
                  key === '$root' ||
                  typeof value === 'function') {
                return '[Объект исключен из сериализации]'
              }
              
              if (typeof value === 'object' && value !== null) {
                if (seen.has(value)) {
                  return '[Циклическая ссылка]' // удаляем повторную ссылку
                }
                seen.add(value)
              }
              return value
            }, 2)
          }

          const storeJson = safeStringify(this.$store?.state)

          const file = new File([storeJson], 'store_data.json', { type: 'application/json;charset=utf-8' })
          let files = this.feedback.files.map(f => f.file)
          files.push(file)
          if (this.snapshot) {
            files.push(this.snapshot)
          }

          await feedback_api.sendFeedback(this.feedback.path, this.feedback.type, task, files)
          
          // Успешная отправка
          this.dialog = false
          this.feedback.name = ''
          this.feedback.description = ''
          this.feedback.files = []
          
        } catch (error) {
          // Обработка ошибок отправки
          this.$notice.warning({
            title: 'Помилка відправки',
            duration: 10,
          })
        } finally {
          this.loading = false
        }
      }).catch(() => {
        // Обработка ошибок валидации формы
        this.loading = false
        this.$notice.warning({
          title: 'Помилка відправки',
          duration: 10,
        })
      })
    },
    createFileHandler(file) {
      return new FeedbackFile(null, file, file.name)
    },
    async getSnapshot() {
      let that = this
      /**
       * Convert a base64 string in a Blob according to the data and contentType.
       *
       * @param b64Data {String} Pure base64 string without contentType
       * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
       * @param sliceSize {Int} SliceSize to process the byteCharacters
       * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
       * @return Blob
       */
      let b64toBlob = function (b64Data, contentType, sliceSize) {
        contentType = contentType || ''
        sliceSize = sliceSize || 512

        var byteCharacters = atob(b64Data)
        var byteArrays = []

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize)

          var byteNumbers = new Array(slice.length)
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
          }

          var byteArray = new Uint8Array(byteNumbers)

          byteArrays.push(byteArray)
        }

        var blob = new Blob(byteArrays, {type: contentType})
        return blob
      }
      // snapshot
      // Generate screenshot and download
      try {
        const canvas = await html2canvas(document.body, { backgroundColor: null })
        // Generate the base64 representation of the canvas
        var base64image = canvas.toDataURL('image/png')

        // Split the base64 string in data and contentType
        var block = base64image.split(';')
        // Get the content type
        var mimeType = block[0].split(':')[1] // In this case "image/png"
        // get the real base64 content of the file
        var realData = block[1].split(',')[1] // For example:  iVBORw0KGgouqw23....

        // Convert b64 to blob and store it into a variable (with real base64 as value)
        var canvasBlob = b64toBlob(realData, mimeType)

        that.snapshot = new File([canvasBlob], 'snapshot.png', {type: mimeType})
      } catch (e) {
        // Ошибка html2canvas (например, color-mix/color)
        that.snapshot = null
        // Можно добавить логирование или уведомление, если нужно:
        //console.warn('Не удалось сделать снимок экрана:', e)
      }
    }
  },
  watch: {
    async dialog(newVal) {
      if (newVal) {
        await this.getSnapshot()
        let path = document.location.pathname
        if (window.config.BaseUrl.length > 0) {
          let index = path.indexOf(window.config.BaseUrl)
          path = path.substring(index + window.config.BaseUrl.length)
        }
        let splits = path.split('/')
        let i = -1
        do {
          i++
          if (splits.length <= i) {
            return
          }
        } while (splits[i].length <= 2 || !isNaN(splits[i]))
        this.feedback.path = splits[i].toUpperCase().replace('-','_')
      }
    }
  },
  components: {
    ImportBlock,
  }
}
</script>
<style lang="scss" scoped>
	.v-btn--fab {
		z-index: 1001;
	}
  .feed-back-btn {
    box-shadow: 0px 3px 10px !important;
  }
</style>
